import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import styled from "styled-components";
import Flex from "./Flex";
import { colorMixin, spacingMixin, typographyMixin } from "../../helpers";

type Story = ComponentStory<typeof Flex>;

export default {
    title: "common/Flex",
    component: Flex
} as ComponentMeta<typeof Flex>;

const Item = styled.div`
    ${typographyMixin("label-small-medium")};
    color: ${colorMixin("text-primary-900")};
    background: ${colorMixin("background-primary-50")};
    padding: ${spacingMixin(1)} ${spacingMixin(1.5)};
    border-radius: 6px;
`;

const Template: Story = args => (
    <Flex {...args}>
        <Item>One</Item>
        <Item>Two</Item>
        <Item>Three</Item>
    </Flex>
);

export const Default = Template.bind({});

export const Column = Template.bind({});
Column.args = {
    column: true
};

export const WithSpacing = Template.bind({});
WithSpacing.args = {
    spacing: 1
};

export const ColumnWithSpacing = Template.bind({});
ColumnWithSpacing.args = {
    spacing: 1,
    column: true
};

export const CustomSpacing = Template.bind({});
CustomSpacing.args = {
    spacing: 3
};
